import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
import { Shield, Receipt, Scissors, Sprout } from 'lucide-react';
export function FourPockets() {
  const pockets = [{
    icon: Shield,
    title: '1. Supervivencia',
    desc: 'Mínimo viable real. Lo que necesitás sí o sí para no caer.'
  }, {
    icon: Receipt,
    title: '2. Impuestos',
    desc: 'Para que no te exploten. AFIP no te sorprende si vos no desaparecés.'
  }, {
    icon: Scissors,
    title: '3. Deuda',
    desc: 'Método cuchillo: una prioridad, el resto se congela.'
  }, {
    icon: Sprout,
    title: '4. Futuro',
    desc: 'Micro-ahorro ridículo, pero constante. Para romper la inercia.'
  }];
  return <Section bg="section" data-id="element-1">
      <FadeIn data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-3">
          El mecanismo: Mapa de Plata en 4 Bolsillos
        </h2>
        <p className="text-xl text-center text-text-secondary font-serif italic mb-12" data-id="element-4">
          No es “presupuesto”. Es asignación.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-5">
        {pockets.map((pocket, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-6">
            <div className="bg-white p-6 rounded-xl border border-warm-border h-full shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-7">
              <div className="flex items-center gap-3 mb-3" data-id="element-8">
                <div className="p-2 bg-warm-highlight rounded-lg text-accent-teal" data-id="element-9">
                  <pocket.icon className="w-6 h-6" data-id="element-10" />
                </div>
                <h3 className="text-lg font-bold" data-id="element-11">{pocket.title}</h3>
              </div>
              <p className="text-text-secondary" data-id="element-12">{pocket.desc}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-13">
        <div className="bg-accent-teal/10 border border-accent-teal/20 p-6 rounded-lg text-center mb-16" data-id="element-14">
          <p className="text-lg font-medium text-accent-teal-hover" data-id="element-15">
            La regla es simple: la plata sin destino se evapora.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.5} data-id="element-16">
        <h3 className="text-2xl font-bold mb-6" data-id="element-17">“Pero yo ya probé…”</h3>
        <p className="text-lg mb-6" data-id="element-18">Sí. Probaste.</p>
        <ul className="space-y-2 mb-8 text-text-secondary" data-id="element-19">
          <li className="flex items-center gap-2" data-id="element-20">
            <span className="w-1.5 h-1.5 bg-text-secondary rounded-full" data-id="element-21"></span>
            Probaste planillas complicadas
          </li>
          <li className="flex items-center gap-2" data-id="element-22">
            <span className="w-1.5 h-1.5 bg-text-secondary rounded-full" data-id="element-23"></span>
            Probaste “ser disciplinado”
          </li>
          <li className="flex items-center gap-2" data-id="element-24">
            <span className="w-1.5 h-1.5 bg-text-secondary rounded-full" data-id="element-25"></span>
            Probaste cortar gastos de golpe
          </li>
          <li className="flex items-center gap-2" data-id="element-26">
            <span className="w-1.5 h-1.5 bg-text-secondary rounded-full" data-id="element-27"></span>
            Probaste ignorar números para respirar un rato
          </li>
        </ul>

        <p className="text-lg mb-6" data-id="element-28">
          ¿Y qué pasó? Que la vida real te pegó una semana mala y te rompió el
          plan.
        </p>

        <p className="text-xl font-serif font-bold text-accent-warm" data-id="element-29">
          Este sistema está diseñado para eso: se dobla, pero no se quiebra.
        </p>
      </FadeIn>
    </Section>;
}